import React from 'react';
import { useLanguage } from '../context/LanguageContext';

/**
 * Language toggle component for switching between English and Spanish
 */
const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button 
      onClick={toggleLanguage}
      className="flex items-center justify-center px-2 py-1 rounded-md border border-white/20 hover:bg-white/10 transition focus:outline-none"
      aria-label={language === 'en' ? "Switch to Spanish" : "Switch to English"}
    >
      <span className={`mr-1 ${language === 'en' ? 'font-bold text-white' : 'text-gray-400'}`}>EN</span>
      <span className="text-gray-400 mx-1">|</span>
      <span className={`ml-1 ${language === 'es' ? 'font-bold text-white' : 'text-gray-400'}`}>ES</span>
    </button>
  );
};

export default LanguageToggle;